import React, { useState } from 'react';
import { Info } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from 'shadcn/components/ui/Dialog';

export function PurchaseOrderBulkUploadInstructionsDialog() {
    const [open, setOpen] = useState(false);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-fit px-2 shrink-0 [&_svg]:size-5"
                    aria-label="Bulk upload instructions"
                >
                    More information <Info className="h-5 w-5" aria-hidden="true" />
                </Button>
            </DialogTrigger>
            <DialogContent className="max-w-lg sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>Bulk upload instructions</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 text-sm leading-relaxed">
                    <p>
                        Upload a CSV file to create multiple purchase orders at once. The file will be validated before
                        you can save.
                    </p>
                    <p>
                        <b>Limit:</b> 1500 rows per upload.
                    </p>
                    <div>
                        <p className="font-semibold">Actions</p>
                        <ul className="mt-1 list-disc space-y-1 pl-5">
                            <li>
                                <b>add</b> — Add a new purchase order
                            </li>
                            <li>
                                <b>add_item</b> — Add items to an existing purchase order
                            </li>
                            <li>
                                <b>override</b> — Override an existing purchase order item
                            </li>
                            <li>
                                <b>remove</b> — Remove an existing purchase order
                            </li>
                        </ul>
                    </div>
                    <p>
                        <b>Grouping rows:</b> Multiple lines can be grouped as one purchase order by keeping the
                        following fields the same: Facility, Vendor, Shipper, Delivery Type, Scheduled Delivery Date.
                    </p>
                    <p>
                        <b>Confirmed:</b> Optional. Use <b>true</b>/<b>false</b> or <b>yes</b>/<b>no</b>. On{' '}
                        <b>override</b>, a confirmed value marks the purchase order as confirmed.
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    );
}
